import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';
import {
  taxonomyLookupModalSetIsLoadingReducerType,
  taxonomyLookupModalSetOpModelReducerType,
  taxonomyLookupModalSetSuggestConfigReducerType,
  taxonomyLookupModalSetBoundOperatorReducerType,
  taxonomyLookupModalSetSearchReducerType,
  taxonomyLookupModalSetSelectedItemsReducerType,
  taxonomyLookupModalSetTotalHitCountReducerType,
  taxonomyLookupModalSetTransferEnabledReducerType,
} from './TaxonomyLookupModalConstants';

export const initialState = Map({
  isLoading: false,
  opModel: {
    title: null,
    selection: [],
  },
  boundOperator: null,
  suggestConfig: null,
  search: '',
  selectedItems: [],
  totalHitCount: 0,
  transferEnabled: false,
});

const spec = {
  [taxonomyLookupModalSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [taxonomyLookupModalSetOpModelReducerType]: (state, action) => {
    const { opModel } = action.payload;
    return state.set('opModel', opModel);
  },
  [taxonomyLookupModalSetSuggestConfigReducerType]: (state, action) => {
    const { suggestConfig } = action.payload;
    return state.set('suggestConfig', suggestConfig);
  },
  [taxonomyLookupModalSetBoundOperatorReducerType]: (state, action) => {
    const { boundOperator } = action.payload;
    return state.set('boundOperator', boundOperator);
  },
  [taxonomyLookupModalSetSearchReducerType]: (state, action) => {
    const { search } = action.payload;
    return state.set('search', search);
  },
  [taxonomyLookupModalSetSelectedItemsReducerType]: (state, action) => {
    const { selectedItems } = action.payload;
    return state.set('selectedItems', selectedItems);
  },
  [taxonomyLookupModalSetTotalHitCountReducerType]: (state, action) => {
    const { totalHitCount } = action.payload;
    return state.set('totalHitCount', totalHitCount);
  },
  [taxonomyLookupModalSetTransferEnabledReducerType]: (state, action) => {
    const { transferEnabled } = action.payload;
    return state.set('transferEnabled', transferEnabled);
  },
};

export default createReducerBySpec(spec, initialState);
